import { env } from 'next-runtime-env';

import type { LoggerServices } from '../constants';
import { LevelMap, LogLevel } from '../constants';
import type { TLoggerMessages } from '../types';

export abstract class BaseLogger {
	protected static checkLogLevel(level: LogLevel): boolean {
		const allowedLevel = (env('NEXT_PUBLIC_LOG_LEVEL') as LogLevel) ?? 'warn';
		const numericLevel = LevelMap[level];
		const numericAllowedLevel = LevelMap[allowedLevel];
		return numericLevel >= numericAllowedLevel;
	}

	abstract log(
		level: LogLevel,
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	): void;

	error = (
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	) => this.log(LogLevel.error, service, message, payload);

	warn = (
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	) => this.log(LogLevel.warn, service, message, payload);

	info = (
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	) => this.log(LogLevel.info, service, message, payload);

	debug = (
		service: LoggerServices,
		message?: TLoggerMessages,
		payload?: Record<string, unknown>
	) => this.log(LogLevel.debug, service, message, payload);
}
